export default [
  {
    path: '/search',
    name: 'search',
    component: () => import('@/views/explore/search.vue'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/clazz/:clazz_id(\\d+)',
    name: 'clazz',
    component: () => import('@/views/clazz/clazz.vue'),
    meta: {
      noAuth: true
    }
  },
  {
    path: '/clazz/poster',
    name: 'clazzposter',
    component: () => import('@/views/clazz/clazzposter.vue')
  },
  {
    path: '/clazz/:clazz_id(\\w+)/enroll/show',
    name: 'clazzenrollshow',
    component: () => import('@/views/enroll/enrollshow.vue')
  },
  {
    path: '/clazz/:clazz_id(\\w+)/rule',
    name: 'clazzrule',
    component: () => import('@/views/clazz/clazzrule.vue')
  },
  {
    path: '/join/clazz/:clazz_id(\\w+)',
    name: 'joinclazz',
    component: () => import('@/views/clazz/joinclazz.vue')
  },
  {
    path: '/join/clazz/:clazz_id(\\w+)/rank',
    name: 'joinclazzrank',
    component: () => import('@/views/clazz/joinclazzrank.vue')
  },
  {
    path: '/join/clazz/:clazz_id(\\w+)/data',
    name: 'joinclazzdata',
    component: () => import('@/views/clazz/joinclazzdata.vue')
  },
  {
    path: '/join/clazz/:clazz_id(\\w+)/review',
    name: 'joinclazzreview',
    component: () => import('@/views/clazz/joinclazzreview.vue')
  },
  // {
  //   path: '/daka',
  //   name: 'daka',
  //   component: () => import('@/views/record/daka.vue')
  // },
  {
    path: '/join/clazz/:clazz_id(\\w+)/week/report',
    name: 'joinclazzweekreport',
    component: () => import('@/views/clazz/weekreport.vue')
  },
  {
    path: '/my/clazz/card',
    name: 'myclazzcard',
    component: () => import('@/views/clazz/card.vue')
  }
]
